import { useMutation, useQuery, useQueryClient } from 'react-query';
import { PROVIDER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { routeReplacer } from '~/Helpers/String.helper';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { IOrganisationSettings } from '~/Models/DTO/Organisation.model';

export const useRequestOrganisationSettings = (organisationId?: string) => {
  const result = useQuery(
    [REQUEST_ACTIONS.GET_ORGANISATION_SETTINGS, organisationId],
    async () =>
      requestReactQuery<IOrganisationSettings>({
        url: routeReplacer(PROVIDER_SERVICE_URLS.ORGANISATION_SETTINGS, {
          organisationId: organisationId || '0',
        }),
        config: { method: 'GET' },
      }),
    {
      enabled: !!organisationId,
    },
  );

  return result;
};

export const useMutateOrganisationSettings = (organisationId?: string) => {
  const queryClient = useQueryClient();
  const revalidate = () =>
    queryClient.invalidateQueries({
      queryKey: [REQUEST_ACTIONS.GET_ORGANISATION_SETTINGS, organisationId],
    });

  const mutation = useMutation(
    async (payload: IOrganisationSettings) =>
      requestReactQuery<IOrganisationSettings>({
        url: routeReplacer(PROVIDER_SERVICE_URLS.ORGANISATION_SETTINGS, {
          organisationId: organisationId || '0',
        }),
        data: payload,
        config: { method: 'POST' },
      }),
    {
      onSuccess: revalidate,
    },
  ).mutate;

  return mutation;
};
